import { Slot } from "components/common/Slot/model"
import { Slide } from "components/common/Slide/model"


import slide1img from './assets/191106-BS-IGB-F1-Golden-Harvest-Festival.jpg';
import slide2img from './assets/191108-BS-IGB-New-F1-Hongsils-Treasure-Draw.jpg';
import slide3img from './assets/191108-BS-F1-Banner-NCoin-Promo.jpg';
import slide4img from './assets/NewF1Banner_BladeAndSoul.jpg';
import slide5img from './assets/skyscraper-Banner-1.jpg';
import slide5rollover from './assets/st-1-phishing-hover.jpg';

import slide6img from './assets/skyscraper-Banner-2.jpg';
import slide6rollover from './assets/st-2-premium-hover.jpg';

import blackFridayImg from './assets/191126-BS-IGB-F1-Black-Friday.jpg';
import destroyerImg from './assets/191203-BS-IGB-F1-Destroyer-3rd-Spec-Preview.jpg';
import willOfIronImg from './assets/191127-BS-IGB-F1-Will-of-Iron-Announcement.jpg';

import articleImg1 from './assets/BS_Embed_PNOverview_Systems.jpg';
import articleImg2 from './assets/BS_News_BladeGhoul_PNOverview_Embed_Candycloud.jpg';

import storeImg1 from './assets/191016-BS-IGB-HM-Blade-n-Ghoul-RNG-2.jpg';
import storeImg2 from './assets/191011-BS-IGB-HM-CR-Ghoulish.jpg';
import storeImg3 from './assets/191015-BS-IGB-HM1-Pet-Pouch-Shiba.jpg';

import lobbyImg1 from './assets/191009-BS-IGB-Lobby-Blade-n-Ghoul.jpg';
import lobbyImg2 from './assets/191016-BS-IGB-Lobby-Blade-n-Ghoul-RNG.jpg';
import lobbyImg3 from './assets/191014-BS-IGB-F1-Lobby-WC-2019-Stream-Giveaway.jpg';

const storeSlide1: Slide = {
  id: 'ss1',
  type: 'slide',
  description: {
    'en-NA': 'Pick up your 1 NCoin Frost Dragon Treasure Chest Today',
    'en-EU': 'Pick up your 1 NCoin Frost Dragon Treasure Chest Today',
    'uk-NA': `Pick up your 1 NCoin Frost Dragon Treasure Chest Today`,
    'uk-EU': `Pick up your 1 NCoin Frost Dragon Treasure Chest Today`,
    'fr-NA': `Aujourd'hui, obtenez un coffre au trésor du Givre du dragon pour seulement 1 NCoin`,
    'fr-EU': `Aujourd'hui, obtenez un coffre au trésor du Givre du dragon pour seulement 1 NCoin`,
    'de-NA': `Holt euch für 1 NCoin eure Schatztruhe des mystischen Drachenfrosts`,
    'de-EU': `Holt euch für 1 NCoin eure Schatztruhe des mystischen Drachenfrosts`,
    'pt-NA': `Garanta a sua NCoin do Baú de Tesouro do Dragão Congelante hoje mesmo!`,
    'pt-EU': `Garanta a sua NCoin do Baú de Tesouro do Dragão Congelante hoje mesmo!`
  },
  media: {
    type: 'image',
    url: storeImg1
  },
  // hoverMedia: {
  //   id: '',
  //   type: 'image',
  // },
  ctaUrl: {
    'en-NA': 'nc://bns.Common/OpenIngameShop?categoryId=235&goodsId=5907612',
    'en-EU': 'nc://bns.Common/OpenIngameShop?categoryId=235&goodsId=5907612',
    'uk-NA': `nc://bns.Common/OpenIngameShop?categoryId=235&goodsId=5907612`,
    'uk-EU': `nc://bns.Common/OpenIngameShop?categoryId=235&goodsId=5907612`,
    'fr-NA': `nc://bns.Common/OpenIngameShop?categoryId=235&goodsId=5907612`,
    'fr-EU': `nc://bns.Common/OpenIngameShop?categoryId=235&goodsId=5907612`,
    'de-NA': `nc://bns.Common/OpenIngameShop?categoryId=235&goodsId=5907612`,
    'de-EU': `nc://bns.Common/OpenIngameShop?categoryId=235&goodsId=5907612`,
    'pt-NA': `nc://bns.Common/OpenIngameShop?categoryId=235&goodsId=5907612`,
    'pt-EU': `nc://bns.Common/OpenIngameShop?categoryId=235&goodsId=5907612`
  },

}

const storeSlide2: Slide = {
  id: 'ss2',
  type: 'slide',
  description: {
    'en-NA': 'Officially licensed Blade & Soul gear is now available. Visit For Fans By Fans and order today.',
    'en-EU': 'Officially licensed Blade & Soul gear is now available. Visit For Fans By Fans and order today.',
    'uk-NA': `Officially licensed Blade & Soul gear is now available. Visit For Fans By Fans and order today.`,
    'uk-EU': `Officially licensed Blade & Soul gear is now available. Visit For Fans By Fans and order today.`,
    'fr-NA': `Besoin d'un coup de main ? N'hésitez pas à vous rendre sur la page de notre service client`,
    'fr-EU': `Besoin d'un coup de main ? N'hésitez pas à vous rendre sur la page de notre service client`,
    'de-NA': `Werft euch mit dem Kostüm „Makaber“ oder „Rächer der Schatten“ für Halloween in Schale`,
    'de-EU': `Werft euch mit dem Kostüm „Makaber“ oder „Rächer der Schatten“ für Halloween in Schale`,
    'pt-NA': `Precisa de uma mãozinha? Acesse a nossa página de suporte para `,
    'pt-EU': `Precisa de uma mãozinha? Acesse a nossa página de suporte para `
  },
  disclaimer: {
    'en-NA': ``,
    'en-EU': ``,
    'uk-NA': ``,
    'uk-EU': ``,
    'fr-NA': ``,
    'fr-EU': ``,
    'de-NA': ``,
    'de-EU': ``,
    'pt-NA': ``,
    'pt-EU': ``
  },
  media: {
    type: 'image',
    url: storeImg2
  },
  // hoverMedia: {
  //   id: '',
  //   type: 'image',
  // },
  ctaUrl: {
    'en-NA': 'nc://bns.Common/OpenIngameShop?categoryId=235&goodsId=5907536',
    'en-EU': 'nc://bns.Common/OpenIngameShop?categoryId=235&goodsId=5907536',
    'uk-NA': `nc://bns.Common/OpenIngameShop?categoryId=235&goodsId=5907536`,
    'uk-EU': `nc://bns.Common/OpenIngameShop?categoryId=235&goodsId=5907536`,
    'fr-NA': `nc://bns.Common/OpenIngameShop?categoryId=235&goodsId=5907536`,
    'fr-EU': `nc://bns.Common/OpenIngameShop?categoryId=235&goodsId=5907536`,
    'de-NA': `nc://bns.Common/OpenIngameShop?categoryId=235&goodsId=5907536`,
    'de-EU': `nc://bns.Common/OpenIngameShop?categoryId=235&goodsId=5907536`,
    'pt-NA': `nc://bns.Common/OpenIngameShop?categoryId=235&goodsId=5907536`,
    'pt-EU': `nc://bns.Common/OpenIngameShop?categoryId=235&goodsId=5907536`
  },
}

const storeSlide3: Slide = {
  id: 'ss3',
  type: 'slide',
  description: {
    'en-NA': 'Pick up your 1 NCoin Frost Dragon Treasure Chest Today',
    'en-EU': 'Pick up your 1 NCoin Frost Dragon Treasure Chest Today',
    'uk-NA': `Pick up your 1 NCoin Frost Dragon Treasure Chest Today`,
    'uk-EU': `Pick up your 1 NCoin Frost Dragon Treasure Chest Today`,
    'fr-NA': `Fondez devant l'adorable sachet de pierre d'illusion de shiba`,
    'fr-EU': `Fondez devant l'adorable sachet de pierre d'illusion de shiba`,
    'de-NA': `Fast zu süß, um wahr zu sein: der Hund von Shiva`,
    'de-EU': `Fast zu süß, um wahr zu sein: der Hund von Shiva`,
    'pt-NA': `Tenha uma overdose de fofura com a Bolsa de Mascote Shiba`,
    'pt-EU': `Tenha uma overdose de fofura com a Bolsa de Mascote Shiba`
  },
  disclaimer: {
    'en-NA': `*Not Available in All Countries`,
    'en-EU': `*Not Available in All Countries`,
    'uk-NA': `*Not Available in All Countries`,
    'uk-EU': `*Not Available in All Countries`,
    'fr-NA': `*Indisponible dans certains pays`,
    'fr-EU': `*Indisponible dans certains pays`,
    'de-NA': `*Nicht in allen Ländern erhältlich`,
    'de-EU': `*Nicht in allen Ländern erhältlich`,
    'pt-NA': `*Not Available in All Countries`,
    'pt-EU': `*Not Available in All Countries`
  },
  media: {
    type: 'image',
    url: storeImg3
  },
  // hoverMedia: {
  //   id: '',
  //   type: 'image',
  // },
  ctaUrl: {
    'en-NA': 'nc://bns.Common/OpenIngameShop?categoryId=235&goodsId=5907618',
    'en-EU': 'nc://bns.Common/OpenIngameShop?categoryId=235&goodsId=5907618',
    'uk-NA': `nc://bns.Common/OpenIngameShop?categoryId=235&goodsId=5907618`,
    'uk-EU': `nc://bns.Common/OpenIngameShop?categoryId=235&goodsId=5907618`,
    'fr-NA': `nc://bns.Common/OpenIngameShop?categoryId=235&goodsId=5907618`,
    'fr-EU': `nc://bns.Common/OpenIngameShop?categoryId=235&goodsId=5907618`,
    'de-NA': `nc://bns.Common/OpenIngameShop?categoryId=235&goodsId=5907618`,
    'de-EU': `nc://bns.Common/OpenIngameShop?categoryId=235&goodsId=5907618`,
    'pt-NA': `nc://bns.Common/OpenIngameShop?categoryId=235&goodsId=5907618`,
    'pt-EU': `nc://bns.Common/OpenIngameShop?categoryId=235&goodsId=5907618`
  },
}

const lobbySlide1: Slide = {
  id: 'ls1',
  type: 'slide',
  description: {
    'en-NA': `Lucky numbers are coming your way in Hongsil's Treasure Draw`,
    'en-EU': `Lucky numbers are coming your way in Hongsil's Treasure Draw`,
    'uk-NA': `Lucky numbers are coming your way in Hongsil's Treasure Draw`,
    'uk-EU': `Lucky numbers are coming your way in Hongsil's Treasure Draw`,
    'fr-NA': `Préparez vos chiffres porte-bonheur pour le Tirage au trésor de Hongsil`,
    'fr-EU': `Préparez vos chiffres porte-bonheur pour le Tirage au trésor de Hongsil`,
    'de-NA': `Hongsils Schatzjagd wartet mit Glückszahlen auf`,
    'de-EU': `Hongsils Schatzjagd wartet mit Glückszahlen auf`,
    'pt-NA': `Tire os melhores números no Sorteio de Tesouro da Hongsil`,
    'pt-EU': `Tire os melhores números no Sorteio de Tesouro da Hongsil`
  },
  media: {
    type: 'image',
    url: lobbyImg1
  },
  // hoverMedia: {
  //   id: '',
  //   type: 'image',
  // },
  ctaUrl: {
    'en-NA': 'https://www.bladeandsoul.com/en/news/blade-and-ghoul-patch-notes/',
    'en-EU': 'https://www.bladeandsoul.com/en/news/blade-and-ghoul-patch-notes/',
    'uk-NA': `https://www.bladeandsoul.com/en/news/blade-and-ghoul-patch-notes/`,
    'uk-EU': `https://www.bladeandsoul.com/en/news/blade-and-ghoul-patch-notes/`,
    'fr-NA': `https://www.bladeandsoul.com/fr/news/blade-and-ghoul-patch-notes/`,
    'fr-EU': `https://www.bladeandsoul.com/fr/news/blade-and-ghoul-patch-notes/`,
    'de-NA': `https://www.bladeandsoul.com/de/news/blade-and-ghoul-patch-notes/`,
    'de-EU': `https://www.bladeandsoul.com/de/news/blade-and-ghoul-patch-notes/`,
    'pt-NA': `https://www.bladeandsoul.com/en/news/blade-and-ghoul-patch-notes/`,
    'pt-EU': `https://www.bladeandsoul.com/en/news/blade-and-ghoul-patch-notes/`
  },
}

const lobbySlide2: Slide = {
  id: 'ls2',
  type: 'slide',
  description: {
    'en-NA': 'Get your NCoin refill today to stock up on your favorite Hongmoon Store items',
    'en-EU': 'Get your NCoin refill today to stock up on your favorite Hongmoon Store items',
    'uk-NA': `Get your NCoin refill today to stock up on your favorite Hongmoon Store items`,
    'uk-EU': `Get your NCoin refill today to stock up on your favorite Hongmoon Store items`,
    'fr-NA': `Obtenez des NCoins pour faire le plein de vos objets favoris à la boutique de Hongmoon`,
    'fr-EU': `Obtenez des NCoins pour faire le plein de vos objets favoris à la boutique de Hongmoon`,
    'de-NA': `Füllt noch heute eure NCoin auf, damit euch eure Lieblingsgegenstände aus dem Hongmoon-Shop nicht ausgehen`,
    'de-EU': `Füllt noch heute eure NCoin auf, damit euch eure Lieblingsgegenstände aus dem Hongmoon-Shop nicht ausgehen`,
    'pt-NA': `Grandes prêmios te aguardam no Baú de Tesouro do Dragão Místico Congelante`,
    'pt-EU': `Grandes prêmios te aguardam no Baú de Tesouro do Dragão Místico Congelante`
  },
  media: {
    type: 'image',
    url: lobbyImg2
  },
  // hoverMedia: {
  //   id: '',
  //   type: 'image',
  // },
  ctaUrl: {
    'en-NA': 'nc://bns.Common/OpenIngameShop?categoryId=235&goodsId=5907613',
    'en-EU': 'nc://bns.Common/OpenIngameShop?categoryId=235&goodsId=5907613',
    'uk-NA': `nc://bns.Common/OpenIngameShop?categoryId=235&goodsId=5907613`,
    'uk-EU': `nc://bns.Common/OpenIngameShop?categoryId=235&goodsId=5907613`,
    'fr-NA': `nc://bns.Common/OpenIngameShop?categoryId=235&goodsId=5907613`,
    'fr-EU': `nc://bns.Common/OpenIngameShop?categoryId=235&goodsId=5907613`,
    'de-NA': `nc://bns.Common/OpenIngameShop?categoryId=235&goodsId=5907613`,
    'de-EU': `nc://bns.Common/OpenIngameShop?categoryId=235&goodsId=5907613`,
    'pt-NA': `nc://bns.Common/OpenIngameShop?categoryId=235&goodsId=5907613`,
    'pt-EU': `nc://bns.Common/OpenIngameShop?categoryId=235&goodsId=5907613`
  },
  disclaimer: {
    'en-NA': `*Not Available in All Countries`,
    'en-EU': `*Not Available in All Countries`,
    'uk-NA': `*Not Available in All Countries`,
    'uk-EU': `*Not Available in All Countries`,
    'fr-NA': `*Indisponible dans certains pays`,
    'fr-EU': `*Indisponible dans certains pays`,
    'de-NA': `*Nicht in allen Ländern erhältlich`,
    'de-EU': `*Nicht in allen Ländern erhältlich`,
    'pt-NA': `*Not Available in All Countries`,
    'pt-EU': `*Not Available in All Countries`
  },
}

const lobbySlide3: Slide = {
  id: 'ls3',
  type: 'slide',
  description: {
    'en-NA': 'Watch the 2019 Blade & Soul World Championship for special giveaways',
    'en-EU': 'Watch the 2019 Blade & Soul World Championship for special giveaways',
    'uk-NA': `Watch the 2019 Blade & Soul World Championship for special giveaways`,
    'uk-EU': `Watch the 2019 Blade & Soul World Championship for special giveaways`,
    'fr-NA': `Regardez le championnat du monde 2019 de Blade & Soul pour tenter d'obtenir des cadeaux`,
    'fr-EU': `Regardez le championnat du monde 2019 de Blade & Soul pour tenter d'obtenir des cadeaux`,
    'de-NA': `Seht euch die Blade & Soul World Championships 2019 an und erhaltet Give-aways.`,
    'de-EU': `Seht euch die Blade & Soul World Championships 2019 an und erhaltet Give-aways.`,
    'pt-NA': `Assista ao Campeonato Mundial de Blade & Soul 2019 e concorra a prêmios`,
    'pt-EU': `Assista ao Campeonato Mundial de Blade & Soul 2019 e concorra a prêmios`
  },
  media: {
    type: 'image',
    url: lobbyImg3
  },
  // hoverMedia: {
  //   id: '',
  //   type: 'image',
  // },
  ctaUrl: {
    'en-NA': 'https://www.bladeandsoul.com/en/news/2019-world-championship-livestream/',
    'en-EU': 'https://www.bladeandsoul.com/en/news/2019-world-championship-livestream/',
    'uk-NA': `https://www.bladeandsoul.com/en/news/2019-world-championship-livestream/`,
    'uk-EU': `https://www.bladeandsoul.com/en/news/2019-world-championship-livestream/`,
    'fr-NA': `https://www.bladeandsoul.com/fr/news/2019-world-championship-livestream/`,
    'fr-EU': `https://www.bladeandsoul.com/fr/news/2019-world-championship-livestream/`,
    'de-NA': `https://www.bladeandsoul.com/de/news/2019-world-championship-livestream/`,
    'de-EU': `https://www.bladeandsoul.com/de/news/2019-world-championship-livestream/`,
    'pt-NA': `https://www.bladeandsoul.com/en/news/2019-world-championship-livestream/`,
    'pt-EU': `https://www.bladeandsoul.com/en/news/2019-world-championship-livestream/`
  },
}

const slide1: Slide = {
  id: 'slide1',
  type: 'slide',
  description: {
    'en-NA': 'The Destroyer gets an upgrade - learn more about the Way of the Iron Will',
    'en-EU': 'The Destroyer gets an upgrade - learn more about the Way of the Iron Will',
    'uk-NA': `The Destroyer gets an upgrade - learn more about the Way of the Iron Will`,
    'uk-EU': `The Destroyer gets an upgrade - learn more about the Way of the Iron Will`,
    'fr-NA': `Le Destructeur se renforce : apprenez-en plus sur la voie de l'éveil du Léviathan`,
    'fr-EU': `Le Destructeur se renforce : apprenez-en plus sur la voie de l'éveil du Léviathan`,
    'de-NA': `Der Berserker wird aufgewertet – findet mehr über den Weg des eisernen Willens heraus`,
    'de-EU': `Der Berserker wird aufgewertet – findet mehr über den Weg des eisernen Willens heraus`,
    'pt-NA': `O Exterminador acaba de ficar mais forte - saiba mais sobre a Bravura do Caminho de Aço`,
    'pt-EU': `O Exterminador acaba de ficar mais forte - saiba mais sobre a Bravura do Caminho de Aço`
  },
  media: {
    type: 'image',
    url: destroyerImg
  },
  // hoverMedia: {
  //   id: '',
  //   type: 'image',
  // },
  ctaUrl: {
    'en-NA': 'https://www.bladeandsoul.com/en/news/destroyer-third-class-specialization-preview/',
    'en-EU': 'https://www.bladeandsoul.com/en/news/destroyer-third-class-specialization-preview/',
    'uk-NA': `https://www.bladeandsoul.com/uk/news/destroyer-third-class-specialization-preview/`,
    'uk-EU': `https://www.bladeandsoul.com/uk/news/destroyer-third-class-specialization-preview/`,
    'fr-NA': `https://www.bladeandsoul.com/fr/news/destroyer-third-class-specialization-preview/`,
    'fr-EU': `https://www.bladeandsoul.com/fr/news/destroyer-third-class-specialization-preview/`,
    'de-NA': `https://www.bladeandsoul.com/de/news/destroyer-third-class-specialization-preview/`,
    'de-EU': `https://www.bladeandsoul.com/de/news/destroyer-third-class-specialization-preview/`,
    'pt-NA': `https://www.bladeandsoul.com/en/news/destroyer-third-class-specialization-preview/`,
    'pt-EU': `https://www.bladeandsoul.com/en/news/destroyer-third-class-specialization-preview/`
  }
}

const slide2: Slide = {
  id: 'slide1',
  type: 'slide',
  description: {
    'en-NA': 'Feel the power of Blade & Soul: Will of Iron on December 11',
    'en-EU': 'Feel the power of Blade & Soul: Will of Iron on December 11',
    'uk-NA': `Feel the power of Blade & Soul: Will of Iron on December 11`,
    'uk-EU': `Feel the power of Blade & Soul: Will of Iron on December 11`,
    'fr-NA': `Imprégnez-vous de la puissance de Blade & Soul : L'éveil du Léviathan le 11 décembre`,
    'fr-EU': `Imprégnez-vous de la puissance de Blade & Soul : L'éveil du Léviathan le 11 décembre`,
    'de-NA': `Spürt am 11. Dezember die Macht von Blade & Soul: Eiserne Äxte`,
    'de-EU': `Spürt am 11. Dezember die Macht von Blade & Soul: Eiserne Äxte`,
    'pt-NA': `Testemunhe o poder em Blade & Soul: Bravura de Aço, dia 11 de dezembro`,
    'pt-EU': `Testemunhe o poder em Blade & Soul: Bravura de Aço, dia 11 de dezembro`
  },
  media: {
    type: 'image',
    url: willOfIronImg
  },
  // hoverMedia: {
  //   id: '',
  //   type: 'image',
  // },
  ctaUrl: {
    'en-NA': 'https://www.bladeandsoul.com/en/news/will-of-iron-announcement/',
    'en-EU': 'https://www.bladeandsoul.com/en/news/will-of-iron-announcement/',
    'uk-NA': `https://www.bladeandsoul.com/uk/news/will-of-iron-announcement/`,
    'uk-EU': `https://www.bladeandsoul.com/uk/news/will-of-iron-announcement/`,
    'fr-NA': `https://www.bladeandsoul.com/fr/news/will-of-iron-announcement/`,
    'fr-EU': `https://www.bladeandsoul.com/fr/news/will-of-iron-announcement/`,
    'de-NA': `https://www.bladeandsoul.com/de/news/will-of-iron-announcement/`,
    'de-EU': `https://www.bladeandsoul.com/de/news/will-of-iron-announcement/`,
    'pt-NA': `https://www.bladeandsoul.com/en/news/will-of-iron-announcement/`,
    'pt-EU': `https://www.bladeandsoul.com/en/news/will-of-iron-announcement/`
  }
}

const slide2bak: Slide = {
  id: 'slide2',
  type: 'slide',
  description: {
    'en-NA': `Lucky numbers are coming your way in Hongsil's Treasure Draw`,
    'en-EU': `Lucky numbers are coming your way in Hongsil's Treasure Draw`,
    'uk-NA': `Lucky numbers are coming your way in Hongsil's Treasure Draw`,
    'uk-EU': `Lucky numbers are coming your way in Hongsil's Treasure Draw`,
    'fr-NA': `Préparez vos chiffres porte-bonheur pour le Tirage au trésor de Hongsil`,
    'fr-EU': `Préparez vos chiffres porte-bonheur pour le Tirage au trésor de Hongsil`,
    'de-NA': `Hongsils Schatzjagd wartet mit Glückszahlen auf`,
    'de-EU': `Hongsils Schatzjagd wartet mit Glückszahlen auf`,
    'pt-NA': `Tire os melhores números no Sorteio de Tesouro da Hongsil`,
    'pt-EU': `Tire os melhores números no Sorteio de Tesouro da Hongsil`
  },
  summary: 'This is a block summary',
  media: {
    type: 'image',
    url: slide2img
  },
  disclaimer: {
    'en-NA': `*Not Available in All Countries`,
    'en-EU': `*Not Available in All Countries`,
    'uk-NA': `*Not Available in All Countries`,
    'uk-EU': `*Not Available in All Countries`,
    'fr-NA': `*Indisponible dans certains pays`,
    'fr-EU': `*Indisponible dans certains pays`,
    'de-NA': `*Nicht in allen Ländern erhältlich`,
    'de-EU': `*Nicht in allen Ländern erhältlich`,
    'pt-NA': `*Not Available in All Countries`,
    'pt-EU': `*Not Available in All Countries`
  },
  ctaUrl: {
    'en-NA': 'https://www.bladeandsoul.com/en/news/hongsils-treasure-draw-nov-2019',
    'en-EU': 'https://www.bladeandsoul.com/en/news/hongsils-treasure-draw-nov-2019',
    'uk-NA': `https://www.bladeandsoul.com/uk/news/hongsils-treasure-draw-nov-2019`,
    'uk-EU': `https://www.bladeandsoul.com/uk/news/hongsils-treasure-draw-nov-2019`,
    'fr-NA': `https://www.bladeandsoul.com/fr/news/hongsils-treasure-draw-nov-2019`,
    'fr-EU': `https://www.bladeandsoul.com/fr/news/hongsils-treasure-draw-nov-2019`,
    'de-NA': `https://www.bladeandsoul.com/de/news/hongsils-treasure-draw-nov-2019`,
    'de-EU': `https://www.bladeandsoul.com/de/news/hongsils-treasure-draw-nov-2019`,
    'pt-NA': `https://www.bladeandsoul.com/en/news/hongsils-treasure-draw-nov-2019`,
    'pt-EU': `https://www.bladeandsoul.com/en/news/hongsils-treasure-draw-nov-2019`
  },
}

const slide3: Slide = {
  id: 'slide3',
  type: 'slide',
  description: {
    'en-NA': 'Get your NCoin refill today to stock up on your favorite Hongmoon Store items',
    'en-EU': 'Get your NCoin refill today to stock up on your favorite Hongmoon Store items',
    'uk-NA': `Get your NCoin refill today to stock up on your favorite Hongmoon Store items`,
    'uk-EU': `Get your NCoin refill today to stock up on your favorite Hongmoon Store items`,
    'fr-NA': `Obtenez des NCoins pour faire le plein de vos objets favoris à la boutique de Hongmoon`,
    'fr-EU': `Obtenez des NCoins pour faire le plein de vos objets favoris à la boutique de Hongmoon`,
    'de-NA': `Füllt noch heute eure NCoin auf, damit euch eure Lieblingsgegenstände aus dem Hongmoon-Shop nicht ausgehen`,
    'de-EU': `Füllt noch heute eure NCoin auf, damit euch eure Lieblingsgegenstände aus dem Hongmoon-Shop nicht ausgehen`,
    'pt-NA': `Recarregue suas NCoin já e garanta seus itens favoritos da Loja Hongmoon`,
    'pt-EU': `Recarregue suas NCoin já e garanta seus itens favoritos da Loja Hongmoon`
  },
  media: {
    type: 'image',
    url: slide3img
  },
  // hoverMedia: {
  //   id: '',
  //   type: 'image',
  // },
  ctaUrl: {
    'en-NA': 'https://www.bladeandsoul.com/en/shop/ncoin/',
    'en-EU': 'https://www.bladeandsoul.com/en/shop/ncoin/',
    'uk-NA': `https://www.bladeandsoul.com/uk/shop/ncoin/`,
    'uk-EU': `https://www.bladeandsoul.com/uk/shop/ncoin/`,
    'fr-NA': `https://www.bladeandsoul.com/fr/shop/ncoin/`,
    'fr-EU': `https://www.bladeandsoul.com/fr/shop/ncoin/`,
    'de-NA': `https://www.bladeandsoul.com/de/shop/ncoin/`,
    'de-EU': `https://www.bladeandsoul.com/de/shop/ncoin/`,
    'pt-NA': `https://www.bladeandsoul.com/en/shop/ncoin/`,
    'pt-EU': `https://www.bladeandsoul.com/en/shop/ncoin/`
  },
}

const slide4: Slide = {
  id: 'slide4',
  type: 'slide',
  description: {
    'en-NA': 'Officially licensed Blade & Soul gear is now available. Visit For Fans By Fans and order today.',
    'en-EU': 'Officially licensed Blade & Soul gear is now available. Visit For Fans By Fans and order today.',
    'uk-NA': `Officially licensed Blade & Soul gear is now available. Visit For Fans By Fans and order today.`,
    'uk-EU': `Officially licensed Blade & Soul gear is now available. Visit For Fans By Fans and order today.`,
    'fr-NA': `Des produits dérivés officiels Blade & Soul sont maintenant disponibles. Rendez-vous dès aujourd'hui sur For Fans By Fans pour les obtenir.`,
    'fr-EU': `Des produits dérivés officiels Blade & Soul sont maintenant disponibles. Rendez-vous dès aujourd'hui sur For Fans By Fans pour les obtenir.`,
    'de-NA': `Jetzt gibt es offiziell lizenziertes Blade & Soul-Merchandise. Besucht For Fans By Fans und bestellt eures noch heute.`,
    'de-EU': `Jetzt gibt es offiziell lizenziertes Blade & Soul-Merchandise. Besucht For Fans By Fans und bestellt eures noch heute.`,
    'pt-NA': `Os produtos oficiais de Blade & Soul já estão disponíveis. Acesse For Fans By Fans e peça já.`,
    'pt-EU': `Os produtos oficiais de Blade & Soul já estão disponíveis. Acesse For Fans By Fans e peça já.`
  },
  media: {
    type: 'image',
    url: slide4img
  },
  // hoverMedia: {
  //   id: '',
  //   type: 'image',
  // },
  ctaUrl: {
    'en-NA': 'https://bladeandsoul.forfansbyfans.com/',
    'en-EU': 'https://bladeandsoul.forfansbyfans.com/',
    'uk-NA': `https://bladeandsoul.forfansbyfans.com/`,
    'uk-EU': `https://bladeandsoul.forfansbyfans.com/`,
    'fr-NA': `https://bladeandsoul.forfansbyfans.com/`,
    'fr-EU': `https://bladeandsoul.forfansbyfans.com/`,
    'de-NA': `https://bladeandsoul.forfansbyfans.com/`,
    'de-EU': `https://bladeandsoul.forfansbyfans.com/`,
    'pt-NA': `https://bladeandsoul.forfansbyfans.com/`,
    'pt-EU': `https://bladeandsoul.forfansbyfans.com/`
  },
}

const slide5: Slide = {
  id: 'slide5',
  type: 'slide',
  description: {
    'en-NA': 'Beware of Phishing Attacks. Read article for more information.',
    'en-EU': 'Beware of Phishing Attacks. Read article for more information.',
    'uk-NA': `Beware of Phishing Attacks. Read article for more information.`,
    'uk-EU': `Beware of Phishing Attacks. Read article for more information.`,
    'fr-NA': `Attention aux tentatives de phishing. Consultez notre article pour plus d'informations.`,
    'fr-EU': `Attention aux tentatives de phishing. Consultez notre article pour plus d'informations.`,
    'de-NA': `Vorsicht: Phishing-Versuche. Weitere Informationen in unserem Artikel.`,
    'de-EU': `Vorsicht: Phishing-Versuche. Weitere Informationen in unserem Artikel.`,
    'pt-NA': `Cuidado com o Phishing. Leia o nosso artigo para saber mais.`,
    'pt-EU': `Cuidado com o Phishing. Leia o nosso artigo para saber mais.`
  },
  media: {
    type: 'image',
    url: slide5img
  },
  hoverMedia: {
    id: '',
    type: 'image',
    url: slide5rollover
  },
  ctaUrl: {
    'en-NA': 'https://support.bladeandsoul.com/hc/en-us/articles/209232666-Beware-of-Phishing-Scams',
    'en-EU': 'https://support.bladeandsoul.com/hc/en-us/articles/209232666-Beware-of-Phishing-Scams',
    'uk-NA': `https://support.bladeandsoul.com/hc/en-us/articles/209232666-Beware-of-Phishing-Scams`,
    'uk-EU': `https://support.bladeandsoul.com/hc/en-us/articles/209232666-Beware-of-Phishing-Scams`,
    'fr-NA': `https://support.bladeandsoul.com/hc/fr/articles/209232666-Beware-of-Phishing-Scams`,
    'fr-EU': `https://support.bladeandsoul.com/hc/fr/articles/209232666-Beware-of-Phishing-Scams`,
    'de-NA': `https://support.bladeandsoul.com/hc/de/articles/209232666-Beware-of-Phishing-Scams`,
    'de-EU': `https://support.bladeandsoul.com/hc/de/articles/209232666-Beware-of-Phishing-Scams`,
    'pt-NA': `https://support.bladeandsoul.com/hc/en-us/articles/209232666-Beware-of-Phishing-Scams`,
    'pt-EU': `https://support.bladeandsoul.com/hc/en-us/articles/209232666-Beware-of-Phishing-Scams`
  },
}

const slide6: Slide = {
  id: 'slide6',
  type: 'slide',
  description: {
    'en-NA': `Become a Premium Member for amazing benefits`,
    'en-EU': `Become a Premium Member for amazing benefits`,
    'uk-NA': `Become a Premium Member for amazing benefits`,
    'uk-EU': `Become a Premium Member for amazing benefits`,
    'fr-NA': `Devenez membre Premium et bénéficiez d'incroyables avantages`,
    'fr-EU': `Devenez membre Premium et bénéficiez d'incroyables avantages`,
    'de-NA': `Werdet Premiummitglied und erhaltet unglaubliche Vorteile`,
    'de-EU': `Werdet Premiummitglied und erhaltet unglaubliche Vorteile`,
    'pt-NA': `Torne-se um Membro Premium e ganhe benefícios incríveis`,
    'pt-EU': `Torne-se um Membro Premium e ganhe benefícios incríveis`
  },
  media: {
    type: 'image',
    url: slide6img
  },
  hoverMedia: {
    id: '',
    type: 'image',
    url: slide6rollover
  },
  ctaUrl: {
    'en-NA': `https://www.bladeandsoul.com/en/shop/premium/`,
    'en-EU': `https://www.bladeandsoul.com/en/shop/premium/`,
    'uk-NA': `https://www.bladeandsoul.com/uk/shop/premium/`,
    'uk-EU': `https://www.bladeandsoul.com/uk/shop/premium/`,
    'fr-NA': `https://www.bladeandsoul.com/fr/shop/premium/`,
    'fr-EU': `https://www.bladeandsoul.com/fr/shop/premium/`,
    'de-NA': `https://www.bladeandsoul.com/de/shop/premium/`,
    'de-EU': `https://www.bladeandsoul.com/de/shop/premium/`,
    'pt-NA': `https://www.bladeandsoul.com/pt/shop/premium/`,
    'pt-EU': `https://www.bladeandsoul.com/pt/shop/premium/`
  },
}

export const slot1: Slot = {
  id: '0',
  label: 'Slot 1',
  slotItemList: [
    slide1
  ]
}

export const slot2: Slot = {
  id: '1',
  label: 'Slot 2',
  slotItemList: [
    slide5
  ]
}

export const slot3: Slot = {
  id: '2',
  label: 'Slot 3',
  slotItemList: [
    slide6
  ]
}

export const primarySlot1: Slot = {
  id: 'p0',
  label: slide1.description,
  disclaimer: slide1.disclaimer,
  slotItemList: [
    slide1
  ]
}

export const primarySlot2: Slot = {
  id: 'p1',
  label: slide2.description,
  disclaimer: slide2.disclaimer,
  slotItemList: [
    slide2
  ]
}

export const primarySlot3: Slot = {
  id: 'p2',
  label: slide3.description,
  disclaimer: slide3.disclaimer,
  slotItemList: [
    slide3
  ]
}

export const primarySlot4: Slot = {
  id: 'p3',
  label: slide4.description,
  disclaimer: slide4.disclaimer,
  slotItemList: [
    slide4
  ]
}

export const primarySlot5: Slot = {
  id: 'p4',
  label: slide5.description,
  disclaimer: slide5.disclaimer,
  slotItemList: [
    slide5
  ],
  hoverMedia: slide5.hoverMedia
}

export const primarySlot6: Slot = {
  id: 'p5',
  label: slide6.description,
  disclaimer: slide6.disclaimer,
  slotItemList: [
    slide6
  ],
  hoverMedia: slide6.hoverMedia
}

export const lobbySlot1: Slot = {
  id: 'l1',
  label: lobbySlide1.description,
  disclaimer: lobbySlide1.disclaimer,
  slotItemList: [
    lobbySlide1
  ]
}

export const lobbySlot2: Slot = {
  id: 'l2',
  label: lobbySlide2.description,
  disclaimer: lobbySlide2.disclaimer,
  slotItemList: [
    lobbySlide2
  ]
}

export const lobbySlot3: Slot = {
  id: 'l3',
  label: lobbySlide3.description,
  disclaimer: lobbySlide3.disclaimer,
  slotItemList: [
    lobbySlide3
  ]
}

export const storeSlot1: Slot = {
  id: 's1',
  label: storeSlide1.description,
  disclaimer: storeSlide1.disclaimer,
  slotItemList: [
    storeSlide1
  ]
}

export const storeSlot2: Slot = {
  id: 's2',
  label: storeSlide2.description,
  disclaimer: storeSlide2.disclaimer,
  slotItemList: [
    storeSlide2
  ]
}

export const storeSlot3: Slot = {
  id: 's3',
  label: storeSlide3.description,
  disclaimer: storeSlide3.disclaimer,
  slotItemList: [
    storeSlide3
  ]
}
